export namespace DatasheetActions {
  export class CalculateDatasheet {
    static readonly type = '[Datasheet] Calculate datasheet';
  }
  export class LoadDatasheet {
    static readonly type = '[Datasheet] Load datasheet';
    constructor(public sendEditedTables: boolean) {}
  }
  export class SaveDatasheet {
    static readonly type = '[Datasheet] Save datasheet';
  }
  export class SetSelectedGroupAndSection {
    static readonly type = '[Datasheet] Set selected group and section';
    constructor(
      public groupId?: number,
      public sectionId?: string
    ) {}
  }
  export class SetSelectedRow {
    static readonly type = '[Datasheet] Set selected row';
    constructor(public rowKey?: string) {}
  }
  export class ClearState {
    static readonly type = '[Datasheet] Clear state';
  }
  export class DownloadDatasheetRequestLog {
    static readonly type = '[Datasheet] Download performance detail request';
  }
  export class UpdateSectionPdfVisibility {
    static readonly type = '[Datasheet] Update section pdf visibility';
    constructor(
      public datasheetNotes: string,
      public sections: string[]
    ) {}
  }
  export class DownloadSelectionDatasheetPdfRequestLog {
    static readonly type = '[Datasheet] Download selection datasheet pdf request';
  }
  export class CreateStudyUnitPdf {
    static readonly type = '[Datasheet] Create Pdf for study unit';
    constructor(
      public studySubcategoryId: string,
      public requestTraceId: string | undefined
    ) {}
  }
  export class DownloadStudyDatasheetPdfRequestLog {
    static readonly type = '[Datasheet] Download study datasheet pdf request';
  }
  export class CreateEaUnitPdf {
    static readonly type = '[Datasheet] Create Pdf for EA unit';
    constructor(public requestTraceId: string | undefined) {}
  }

  export class SetIsEditing {
    static readonly type = '[Datasheet] Set is editing';
    constructor(public isEditing: boolean) {}
  }

  export class SetEditedValues {
    static readonly type = '[Datasheet] Set edited values';
    constructor(public values: Record<string, unknown>) {}
  }

  export class DownloadPartialLoads {
    static readonly type = '[Datasheet] Download partial loads';
  }
}
